import styles from './index.module.sass';

export const DocItem = ({ label, date, onClick }: { label: string, date: string, onClick: () => void }) => {
    return (
        <div className={styles.root}>
            <span className={styles.label}>{label}</span>
            <span className={styles.date}>{date}</span>
            <span className={styles.action}>
                <span className={styles.download}>
                    скачать
                </span>
            </span>
        </div>
    )
}